import { useState } from "react";
import { FileSpreadsheet, FileText, Loader2 } from "lucide-react";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { downloadExport, errMsg } from "@/lib/api";

export function ExportButtons({ collection, custom }) {
  const [busy, setBusy] = useState(null);
  const run = async (fmt) => {
    setBusy(fmt);
    try {
      await downloadExport(collection, fmt, custom ? `${custom}?format=${fmt}` : null);
      toast.success(`Export ${fmt.toUpperCase()} berhasil`);
    } catch (e) { toast.error(errMsg(e)); } finally { setBusy(null); }
  };
  return (
    <div className="flex gap-2">
      <Button variant="outline" size="sm" onClick={() => run("xlsx")} disabled={!!busy} data-testid={`export-xlsx-${collection}`}>
        {busy === "xlsx" ? <Loader2 className="h-4 w-4 animate-spin" /> : <FileSpreadsheet className="h-4 w-4" />} <span className="hidden sm:inline ml-1">Excel</span>
      </Button>
      <Button variant="outline" size="sm" onClick={() => run("pdf")} disabled={!!busy} data-testid={`export-pdf-${collection}`}>
        {busy === "pdf" ? <Loader2 className="h-4 w-4 animate-spin" /> : <FileText className="h-4 w-4" />} <span className="hidden sm:inline ml-1">PDF</span>
      </Button>
    </div>
  );
}
